import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../../../services/localization.service';

@Pipe({
  name: 'localizedDate'
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(
    private localization: LocalizationService,
    private pipe: DatePipe,
  ) { }

  public transform(value: string | number | Date, format: string = 'mediumDate', timezone?: string, locale?: string): string | null {
    if (value === null || value === undefined) {
      return null;
    }

    if (!locale) {
      locale = this.localization.getDateFormatLocale();
    }

    if (format === 'short') {
      // Short only displays hours and minutes, but we also want seconds
      return `${this.pipe.transform(value, 'shortDate', timezone, locale)} ${this.pipe.transform(value, 'mediumTime', timezone, locale)}`;
    }

    return this.pipe.transform(value, format, timezone, locale);
  }
}
